// Takes TanStack Query's own `dataUpdatedAt` rather than a separately tracked clock, so this
// can't drift from the read it describes.
export function formatLastUpdated(dataUpdatedAt: number): string {
    const date = new Date(dataUpdatedAt);
    const datePart = date.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
    });
    const timePart = date
        .toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
        .replace(/\s/g, '')
        .toLowerCase();

    return `Last updated ${datePart}, ${timePart}`;
}
